import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { FaCircle } from 'react-icons/fa';
import './RecentActivities.scss';

const RecentActivities = () => {
  const activities = [
    {
      type: 'property',
      message: 'New property listed: Modern Apartment in Downtown',
      time: '5 minutes ago'
    },
    {
      type: 'maintenance',
      message: 'Maintenance request #123 marked as resolved',
      time: '2 hours ago'
    },
    {
      type: 'user',
      message: 'New user registration: John Smith',
      time: '4 hours ago'
    },
    {
      type: 'property',
      message: 'Property price updated: Beach House Villa',
      time: '1 day ago'
    }
  ];

  const getStatusColor = (type) => {
    switch (type) {
      case 'property':
        return '#4e73df';
      case 'maintenance':
        return '#f6c23e';
      case 'user':
        return '#1cc88a';
      default:
        return '#858796';
    }
  };

  return (
    <Card className="recent-activities">
      <Card.Header>
        <h5 className="m-0">Recent Activities</h5>
      </Card.Header>
      <ListGroup variant="flush">
        {activities.map((activity, index) => (
          <ListGroup.Item key={index} className="activity-item">
            <div className="d-flex align-items-center">
              <FaCircle className="status-dot" style={{ color: getStatusColor(activity.type) }} />
              <div className="ms-3">
                <div className="activity-message">{activity.message}</div>
                <div className="activity-time">{activity.time}</div>
              </div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
};

export default RecentActivities;
